<template>
  <div class="date-view">
    <strong>{{ component.props?.label || 'Date' }}:</strong>
    {{ today }}
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
  shareValue: { type: Number, default: 2 },
  ballotComponents: { type: Array, default: () => [] },
})

const today = computed(() => {
  return new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
})
</script>

<style scoped>
.date-view {
  padding: 10px 0;
}
</style>
